import {
  schoolTestApi,
  type SchoolTestFileParams,
  type SchoolTestListParams,
  type SchoolTestPdfDownloadLogBody,
  type SchoolTestSchoolsParams,
  type SchoolTestsGroupBySchoolParams,
} from '@mathflat/domain/SchoolTest'

import { SchoolTest } from '@/dto/SchoolTest/SchoolTest'

class SchoolTestController {
  fetchSchoolTestList = async (params: SchoolTestListParams, signal?: AbortSignal) => {
    const slice = await schoolTestApi.getSchoolTests(params, { signal })
    return { ...slice, content: slice.content.map((schoolTest) => new SchoolTest(schoolTest)) }
  }

  fetchSchoolTestDownloadInfo = (params: SchoolTestFileParams) =>
    schoolTestApi.getSchoolTestFile(params)

  fetchSchoolsBySchoolInfo = (params: SchoolTestSchoolsParams, signal?: AbortSignal) =>
    schoolTestApi.getSchoolTestSchools(params, { signal })

  fetchSchoolTestsGroupBySchool = (params: SchoolTestsGroupBySchoolParams) =>
    schoolTestApi.getSchoolTestsGroupBySchool(params)

  fetchMonthlyPdfQuotaStatus = () => schoolTestApi.getSchoolTestPdfQuota()

  createPdfDownloadLog = (payload: SchoolTestPdfDownloadLogBody) => {
    void schoolTestApi.createSchoolTestPdfDownloadLog(payload)
  }

  fetchRecentlyDownloadedSchools = (size: number) =>
    schoolTestApi.getRecentlyDownloadedSchools(size)
}

export const schoolTestController = new SchoolTestController()
